<template>
  <v-alert v-if="showErrors" :value="showErrors" type="error" outline>
    <div>
      <slot />
      <div>
        <ul>
          <li v-for="error in errorArray" :key="error">
            {{ error }}
          </li>
        </ul>
      </div>
    </div>
  </v-alert>
</template>

<script>
export default {
  name: "errorMessages",
  props: {
    errors: {
      name: "errors",
      type: [Array, String],
      required: false
    }
  },
  computed: {
    showErrors() {
      if (typeof this.errorArray === "string") {
        return true;
      }
      if (Array.isArray(this.errorArray) && this.errorArray.length) {
        return true;
      }
      return false;
    },
    errorArray() {
      console.debug("errorArray", this.errors);
      try {
        if (typeof this.errors == "string") {
          return [this.errors];
        } else if (this.errors.length) {
          console.debug("treating as an array");
          return [
            ...this.errors.map(e => {
              return typeof e == "string" ? e : e.message;
            })
          ];
        }
      } catch (e) {
        return [];
      }
      return [];
    }
  }
};
</script>
